"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withApolloClient = void 0;
const react_1 = __importDefault(require("react"));
const ssr_1 = require("@apollo/client/react/ssr");
const window_1 = require("../utils/window");
const apollo_client_1 = require("./apollo-client");
const withApolloClient = (App, apiUrl, manualRedirects) => {
    var _a;
    return _a = class ApolloApp extends react_1.default.Component {
            constructor(props) {
                super(props);
                this.apolloClient = (0, apollo_client_1.getApolloClient)(apiUrl, props.apolloState);
            }
            static getInitialProps(ctx) {
                return __awaiter(this, void 0, void 0, function* () {
                    const { AppTree } = ctx;
                    let initialProps = { pageProps: {} };
                    if (App.getInitialProps) {
                        initialProps = yield App.getInitialProps(ctx);
                    }
                    const apolloClient = (0, apollo_client_1.getApolloClient)(apiUrl, manualRedirects);
                    if (!(0, window_1.isClientSide)()) {
                        try {
                            yield (0, ssr_1.getDataFromTree)(react_1.default.createElement(AppTree, Object.assign({}, initialProps, { apolloClient: apolloClient })));
                        }
                        catch (error) {
                        }
                    }
                    const apolloState = apolloClient.cache.extract();
                    return Object.assign(Object.assign({}, initialProps), { apolloState });
                });
            }
            render() {
                return react_1.default.createElement(App, Object.assign({ apolloClient: this.apolloClient }, this.props));
            }
        },
        _a.displayName = 'withApollo(App)',
        _a;
};
exports.withApolloClient = withApolloClient;
